<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-xs-12 p-2 pt-4 center">
        <a href="https://jovool.com">
          <img src="/images/Jovool_logo.png" />
        </a>
      </div>
      <div
        style="text-align: right"
        class="pt-4 col-lg-5 col-xs-12"
      >
        <h1 class="color-primary"></h1>
      </div>
      <div class="col-lg-1"></div>
    </div>
    <transition name="fade">
      <div
        class="row"
        v-if="!valid"
      >
        <div class="col-lg-12">
          <div class="row">
            <SignIn
              :account_uid="account_uid"
              :candidate_uid="candidate.uid"
              :bigfive_uid="bigfive.uid"
              :bigfive="true"
            >
              <div class="mt-5">
                <h1 class="center">Teste Bigfive</h1>
                <p class="f15 center">
                  Faça seu login ou cadastre-se para começar o teste
                </p>
              </div>
            </SignIn>
          </div>
        </div>
      </div>
      <div
        class="row"
        v-if="valid"
      >
        <div class="col-lg-1 col-1"></div>
        <div class="col-lg-10 col-10">
          <Test
            :bigfive_uid="bigfive.uid"
            :amount_itens="bigfive.amount_itens"
            :account_uid="account_uid"
            :no_next="true"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import SignIn from "@/Candidates/SignIn/New.vue";
import Test from "@/Bigfives/Test.vue";
export default {
  props: ["bigfive", "account_uid", "candidate_uid"],
  components: { Test, SignIn },
  data: () => ({
    candidate: {
      uid: "",
    },
    valid: false,
    load: false,
  }),
  mounted() {
    if (this.candidate_uid) {
      this.candidate.uid = this.candidate_uid;
      this.valid = true;
    }

    eventBus.$on("candidateLogged", (candidate_uid) => {
      this.candidate.uid = candidate_uid;
      this.valid = true;
    });
  },
};
</script>

